import { sensor_value_type_mapping } from '../Constants/constants';

// Same order and scaling as GCSPIIrrigationTankInfoEntry.measurements.
export const tankMeasurements = [
  {
    key: 'ec_nutrient_solution',
    type: sensor_value_type_mapping.SENS_VAL_NUTRI_EC,
    digits: 2,
    unit: 'mS/cm'
  },
  {
    key: 'ph_nutrient_solution',
    type: sensor_value_type_mapping.SENS_VAL_NUTRI_PH,
    digits: 2,
    unit: 'pH'
  },
  {
    key: 'temp_nutrient_solution',
    type: sensor_value_type_mapping.SENS_VAL_NUTRI_TEMP,
    digits: 1,
    unit: '°C'
  },
  {
    key: 'redox_current',
    type: sensor_value_type_mapping.SENS_VAL_NUTRI_REDOX,
    digits: 0,
    unit: 'mV'
  },
  { key: 'dos_current', type: sensor_value_type_mapping.SENS_VAL_NUTRI_DOS, digits: 1, unit: '%' }
];
export const tankLevelKeys = [
  'tank_level_unknown',
  'tank_level_low',
  'tank_level_above_min',
  'tank_level_full',
  'tank_level_error',
  'tank_level_not_monitored'
];
export const tankOwnsSource = (tank, zone, index) =>
  Number.isInteger(tank.measurement_source_zone) &&
  tank.measurement_source_zone >= 0 &&
  tank.measurement_source_zone < 9 &&
  Number.isInteger(index) &&
  index >= 0 &&
  index < 4 &&
  tank.measurement_source_zone === Number(zone) &&
  tank.measurement_source_index === index;
// Non-zoned controllers still use SAM measurement source 0, although their
// GUI controller object has the GLOBAL settings scope (254).
export const tankSourceZone = (parent, zoned) => (zoned ? Number(parent.zone_id ?? parent.id) : 0);

export function tankMeasurementValue(tank, index) {
  if (
    !(tank.measurement_configured_mask & (1 << index)) ||
    !(tank.measurement_valid_mask & (1 << index))
  )
    return null;
  return formatTankValue(tank.measurements?.[index], index);
}

export function tankSetpointValue(tank, index) {
  if (index < 0 || index > 2 || !(tank.setpoint_valid_mask & (1 << index))) return null;
  return formatTankValue(tank.setpoints?.[index], index);
}

function formatTankValue(raw, index) {
  if (!Number.isInteger(raw) || raw < -32768 || raw > 32767 || !tankMeasurements[index])
    return null;
  return (raw / 10 ** tankMeasurements[index].digits).toFixed(tankMeasurements[index].digits);
}

export function tankRemainingTime(tank) {
  const seconds = (value) =>
    Number.isInteger(value) && value >= 0 && value < 0xffff ? value : null;
  const allowance = seconds(tank.low_allowance_remaining_seconds);
  const total = seconds(tank.low_grace_remaining_seconds);
  // The transmitted total already includes allowance. Never add it a second time.
  const reserve =
    total !== null && allowance !== null && total >= allowance ? total - allowance : null;
  const format = (value) => (value === null ? '---' : `${value} s`);
  return `${format(allowance)} + ${format(reserve)}`;
}
